export default "__VITE_ASSET__5ba7a9c2__"